import { interWbHttp } from '@interco/inter-webview-bridge'

import { TConsentsResponse, TRevokeConsentRequest } from './types'

export const getConsents = async (authorizationId: string): Promise<TConsentsResponse[]> => {
  const endpoint = `/interid/v1/consents`

  const { response } = await interWbHttp.get(endpoint, {
    'Content-Type': 'application/json',
    'x-api-token': authorizationId,
  })
  const data = JSON.parse(response)

  return data
}

export const postRevokeConsent = async ({ clientId, authorizationId }: TRevokeConsentRequest) => {
  const endpoint = `/interid/v1/revoke-consents`

  const { response } = await interWbHttp.post(
    endpoint,
    {
      clientId,
    },
    { 'x-api-token': authorizationId },
  )

  const data = JSON.parse(response)

  return data
}
